// TODO
class Chain {
  public id: string;
  public numberID: number;
  public allowed: boolean;
  public color: string;
  public rpcUrl: string;
  public symbol: string;
  public name: string;
  public shortedName: string;

  constructor(
    id: string,
    allowed: boolean,
    color: string,
    name: string,
    rpcUrl: string,
    symbol: string = 'ETH',
    shortedName: string = '',
  ) {
    this.id = id;
    this.numberID = parseInt(this.id);
    this.allowed = allowed;
    this.color = color;
    this.name = name;
    this.rpcUrl = rpcUrl;
    this.symbol = symbol;
    this.shortedName = shortedName || this.name;
  }
}

const chains: Chain[] = [
  new Chain(
    '0x1',
    true,
    '#3bb5ae',
    'Ethereum Mainnet',
    'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
  ),
  new Chain(
    '0x3',
    false,
    '#fb508e',
    'Ropsten Testnet',
    'https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
  ),
  new Chain(
    '0x4',
    false,
    '#f4c150',
    'Rinkeby Testnet',
    'https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
  ),
  new Chain(
    '0x5',
    false,
    '#379cef',
    'Goerli Testnet',
    'https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
  ),
  new Chain(
    '0x2a',
    false,
    '#8c6cfb',
    'Kovan Testnet',
    'https://kovan.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
  ),
  new Chain(
    '0x38',
    false,
    '#f9b10b',
    'Binance Mainnet',
    'https://bsc-dataseed.binance.org/',
    'BNB',
  ),
  new Chain(
    '0x61',
    false,
    '#f9b10b',
    'Binance Testnet',
    'https://data-seed-prebsc-1-s2.binance.org:8545/',
    'BNB',
  ),
  new Chain(
    '0xa86a',
    false,
    '#f9b10b',
    'Avalanche Mainnet',
    'https://api.avax.network/ext/bc/C/rpc',
    'AVAX',
  ),
  new Chain(
    '0xa869',
    false,
    '#f9b10b',
    'Avalanche Testnet',
    'https://api.avax-test.network/ext/bc/C/rpc',
    'AVAX',
  ),
  new Chain('0x1228', false, '#5600e4', 'PiLab Testnet', 'http://192.168.0.195:8500'),
];

export default chains;

export { Chain };
